<template>
  <span class="satellite-status" :class="`_${status}`">
    <span
      class="satellite-status__dot"
      v-tooltip="{
        content: label,
        triggers: ['hover', 'click'],
      }"
    ></span>
    <span v-if="showText" class="satellite-status__text">{{ label }}</span>
  </span>
</template>
<script>
export default {
  name: "SatelliteStatus",
  props: {
    status: {
      type: String,
      default: "offline",
    },
    showText: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    label() {
      return this.$t(`satellites.status.${this.status}`);
    },
  },
};
</script>
<style lang="scss" scoped>
$green: #37807d;
$red: #c62424;

.satellite-status {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  white-space: nowrap;

  &__dot {
    position: relative;
    flex-shrink: 0;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    cursor: default;
  }

  &._online {
    color: $green;

    .satellite-status__dot {
      background: $green;
      box-shadow: 0 0 6px 2px rgba($green, 0.6);
    }
  }

  // Created, the install command has not been run yet: a hollow dot.
  &._pending {
    color: var(--sat-muted, #9b9ba4);

    .satellite-status__dot {
      box-sizing: border-box;
      border: 2px solid currentColor;
    }
  }

  &._installing {
    color: $green;

    .satellite-status__dot {
      background: $green;

      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: $green;
        animation: satellite-pulse 1.6s ease-out infinite;
      }
    }
  }

  &._offline {
    color: $red;

    .satellite-status__dot {
      background: $red;
    }
  }
}

@keyframes satellite-pulse {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    transform: scale(2.8);
    opacity: 0;
  }
}

body.dark .satellite-status {
  &._online,
  &._installing {
    color: #479495;
  }

  &._offline {
    color: #e36464;
  }
}
</style>
